export default class Helper
{
	static unit = {
		millisecond     : 1000,
		second_in_day   : 86400,
		second_in_minute: 60,
		minute_in_hour  : 60,
		hour_in_day     : 24,
	}

	static string(value)
	{
		return typeof value === 'string' || typeof value === 'number' ? String(value) : ''
	}

	static time_pad(value)
	{
		return String(value).padStart(2, '0')
	}

	static range(start, end)
	{
		const list = []
		for(let index = start; index <= end; index++) list.push(index)

		return list
	}

	static escape_html(html)
	{
		const escape = document.createElement('textarea')
		escape.textContent = html

		return escape.innerHTML
	}

	static html_newline(string)
	{
		return string.replace(/\n/g, '<br>\n')
	}
}
